import { useState } from "react";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  getTotalTextLength,
  splitHtmlIntoArray,
} from "@routes/Article/components/ArticleParagraphElements/storyElement/box/utils/helpers";
import StoryElement from "@routes/Article/components/ArticleParagraphElements/storyElement/StoryElement";
import { ArticleStoryElementProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import { BOX_CHARACTER_THRESHOLD } from "@routes/Article/components/StoryElements/Box/utils/constants";
import { cn, getBoxHeight } from "@util/helpers";

/**
 * Renders a Box elements that contains multiple story elements.
 */
const Box = ({
  bodyString,
  className,
  paragraphWidth,
  article,
}: ArticleStoryElementProps) => {
  const [boxHeight, setBoxHeight] = useState(0);
  const [isShowing, setIsShowing] = useState(false);

  const handlePress = () => {
    setIsShowing((prev) => !prev);
  };

  // Now you can map over elements to render or process each part
  const htmlArray = splitHtmlIntoArray(bodyString);

  const totalTextLength = getTotalTextLength(htmlArray);

  return (
    <div
      className={cn(
        "mb-6 rounded-[.25rem] border border-gray-175 bg-gray-50 p-8 after:clear-both after:block",
        className,
        paragraphWidth
      )}
      data-testid="article-box-component"
    >
      <div
        ref={(e) => {
          if (setBoxHeight && e) {
            setBoxHeight(e.scrollHeight);
          }
        }}
        className={cn(
          "overflow-hidden transition-all duration-300 ease-in-out"
        )}
        style={{ height: getBoxHeight(totalTextLength, isShowing, boxHeight) }}
      >
        {htmlArray.map((content, index) => {
          return (
            <StoryElement
              key={`body-${index}`}
              bodyString={content}
              isBoxWrapped={true}
              article={article}
            />
          );
        })}
      </div>

      <div className="relative">
        {totalTextLength > BOX_CHARACTER_THRESHOLD ? (
          <>
            {!isShowing ? (
              <div className="absolute bottom-full left-0 right-0 h-[3.75rem] bg-gradient-to-b from-transparent to-gray-50"></div>
            ) : null}

            <ButtonFactory
              buttonType={ButtonType.Secondary}
              onClick={handlePress}
              className="mt-3 block w-full rounded-none border-0 border-t border-gray-175 pt-3 !font-poppins text-base font-semibold leading-6 outline-none hover:border-gray-175"
              text={isShowing ? "Collapse" : "Expand"}
              icon={
                <FontAwesomeIcon
                  icon={isShowing ? faChevronUp : faChevronDown}
                  className="ml-1"
                  height={16}
                  width={16}
                />
              }
            />
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Box;
